import React from 'react';

const WarningBlackIcon = () => {
  return (
    <div className="vbz-icon-beneficiaries">
      <div className="vbz-icon-beneficiaries-warning-black" />
    </div>
  );
};

export default WarningBlackIcon;
